import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import GeneralBackButton from "../../../../../common/AdminCommonComponents/Buttons/GeneralBackButton/GeneralBackButton"
import LightGrayBgWrapper from "../../../../../common/AdminCommonComponents/LightGrayBgWrapper/LightGrayBgWrapper"
import DynamicCardRow from "../../../../DynamicCardRow/DynamicCardRow"
import DynamicButton from "../../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import GrayHeading from "../../../../../common/AdminCommonComponents/GrayHeading/GrayHeading"
import DynamicDropdown from "../../../../../common/AdminCommonComponents/DynamicDropdown/DynamicDropdown"

const AddNewRole = () => {

  const statsData = [
    { title: "Total aDMINS".toUpperCase(), value: 0 },
    { title: "Active Admins".toUpperCase(), value: 0 },
    { title: "Total Roles".toUpperCase(), value: 0 },
    { title: "Total Permissions".toUpperCase(), value: 0 },
  ]

  const permissionsOptions = [
    { label: 'limited', action: () => console.log('limited') },
    { label: 'all access', action: () => console.log('all access') },
  ]

  const statusOptions = [
    { label: 'Active', action: () => console.log('active') },
    { label: 'Inactive', action: () => console.log('Iactive') },
  ]


  return (
    <LightGrayBgWrapper>
      <div className="bg-white shadow px-4 p-3">
        <div className="fw-semibold fs-5 mb-2">Overview</div>
        <DynamicCardRow cards={statsData} />
      </div>

      <div className="bg-white shadow px-4 p-3 mt-3">
      <GeneralBackButton />
      <div className="d-flex justify-content-center">
        <GrayHeading>Add new Role</GrayHeading>
      </div>

      <Form className="mt-3" onSubmit={(e) => e.preventDefault()}>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-medium" for="roleID">Role ID</Label>
              <Input id="roleID" name="roleID" placeholder="Role ID" type="number" />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-medium" for="roleName">Role Name</Label>
              <Input id="roleName" name="roleName" placeholder="Role Name" type="text" />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-medium" for="roleDescription">Role Description</Label>
              <Input id="roleDescription" name="roleDescription" placeholder="Role Description" type="text" />
              {/* <Input type="select">
                <option disabled selected hidden>
                  Select
                </option>
                <option>Option 1</option>
                <option>Option 2</option>
              </Input> */}
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-medium" for="permissions">Permissions</Label>
              <DynamicDropdown options={permissionsOptions} />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-medium" for="status">Status</Label>
              <DynamicDropdown options={statusOptions} />
            </FormGroup>
          </Col>
        </Row>

        <div className="d-flex justify-content-end gap-3 my-3">
          <DynamicButton theme="blue-outline">Cancel</DynamicButton>
          <DynamicButton theme="blue">Submit</DynamicButton>
        </div>
      </Form>
    </div>
    </LightGrayBgWrapper>
  )
}

export default AddNewRole